import { ROUTES } from "constants/index";

export type AccountKind = "company" | "individual";

export function isIndividualAccountPath(pathname: string): boolean {
  return (
    pathname === ROUTES.INDIVIDUAL_NEW ||
    pathname.startsWith(`${ROUTES.INDIVIDUALS}/`)
  );
}

export function isCompanyAccountPath(pathname: string): boolean {
  return (
    pathname === ROUTES.COMPANY_NEW ||
    pathname.startsWith(`${ROUTES.COMPANIES}/`)
  );
}

export function accountViewPath(
  id: string | number,
  kind: AccountKind
): string {
  return kind === "individual"
    ? `/individuals/${id}/view`
    : `/companies/${id}/view`;
}

export function accountEditPath(
  id: string | number,
  kind: AccountKind
): string {
  return kind === "individual"
    ? `/individuals/${id}/edit`
    : `/companies/${id}/edit`;
}

export function accountNewPath(kind: AccountKind): string {
  return kind === "individual" ? ROUTES.INDIVIDUAL_NEW : ROUTES.COMPANY_NEW;
}

export function accountKindFromRowType(
  accountType?: string | null
): AccountKind {
  return accountType?.toLowerCase() === ROUTES.ACCOUNT_TYPE_INDIVIDUAL
    ? "individual"
    : "company";
}

export function accountViewPathFromRow(
  id: string | number,
  accountType?: string | null
): string {
  return accountViewPath(id, accountKindFromRowType(accountType));
}

/** Redirect legacy /companies/...?accountType=individual URLs to /individuals/... */
export function legacyIndividualRedirectTarget(
  pathname: string,
  id: string | undefined,
  accountTypeParam: string | null
): string | null {
  if (accountTypeParam !== ROUTES.ACCOUNT_TYPE_INDIVIDUAL) return null;
  if (!isCompanyAccountPath(pathname)) return null;

  if (pathname.endsWith("/view") && id) {
    return accountViewPath(id, "individual");
  }
  if (pathname.endsWith("/edit") && id) {
    return accountEditPath(id, "individual");
  }
  if (pathname === ROUTES.COMPANY_NEW) {
    return ROUTES.INDIVIDUAL_NEW;
  }
  return null;
}
